//--------DOCUMENTATION--------
//This widget has 2 modes for the view: 1) a condensed version, and 2) a full version.  By default, only the condensed 
//version is shown, and the full version is called via AJAX from within the short version.

//    Dependencies:
//1. CDN Chartist.CSS <link rel="stylesheet" href="bower_components/chartist/dist/chartist.min.css">
//2. CDN Chartist.js  <script src="bower_components/chartist/dist/chartist.min.js">
//3. ArticleLevelMetrics.js --> which should ship over in the SharedWidgets NuGet Package
//4. _article-level-metrics.scss --> default presentation for the widget. should ship over with NuGet Package.
var SCM = SCM || {};
var $body = $('body');
var $printableModal = $('.js-printable-metrics-modal');
var ctHtmlLabels = function (options) {
    return function (chart) {
        chart.on('draw',
            function (context) {
                if (context.type === 'label') {
                    var redo = context.element._node.childNodes[0];
                    redo.innerHTML = redo.innerText;
                }
            });
    };
};

SCM.ContentMetric = (function(ns) {

    function fullVersion($dest, routeUrl) {
        // Only do AJAX call if it hasn't been done before.

        var $chart = $dest.find('.js-ct-chart');
        var chartClass = '.ct-chart';
        if ($dest.closest('.widget-SplitView').length) {
            $chart.addClass('sv-ct-chart');
            chartClass = '.sv-ct-chart';
        }
        if ($dest.find('.js-metric-full-wrap').length < 1) {
            var baseSiteUrl = $('#hfSiteURL');

            if (typeof baseSiteUrl != 'undefined' && typeof baseSiteUrl.val() != 'undefined' && baseSiteUrl != '') {
                routeUrl = '//' + baseSiteUrl.val() + routeUrl;
            }

            $.ajax({
                url: routeUrl,
                datatype: 'HTML',
                success: function (html) {
                    $dest.prepend(html);    
                    updateAltmetricPropsForBooksAndArticles();
                    updateChart(ctHtmlLabels, chartClass);                    
                },
                error: function (xmlHttpRequest, textStatus, errorThrown) {
                    if (window.console) {
                        var err = eval('(' + xmlHttpRequest.responseText + ')');
                        console.error('error: ' + err);
                        console.error('status: ' + textStatus);
                    }
                }
            });
        }
        else {
            if ($chart.length === 0 || $chart.html().length === 0) {
                updateAltmetricPropsForBooksAndArticles();               
                $('.js-metric-full-wrap').removeClass('hide');
                updateChart(ctHtmlLabels, chartClass);
            }
        }
    }

    function updateChart(ctHtmlLabels, chartClass) {
        setTimeout(function () {
            if (typeof window.ChartistData !== 'undefined') {
                // Chartist Options
                var opts = {
                    lineSmooth: false,
                    showArea: true,
                    low: 0,
                    plugins: [ctHtmlLabels]
                };

                var responsiveOpts = [
                    [
                        'screen and (max-width: 1024px)', {
                            axisX: {
                                labelInterpolationFnc: function (value) {
                                    return value.slice(0, 3);
                                }
                            }
                        }
                    ],
                    [
                        'screen and (min-width: 1px)', {
                            axisX: {
                                labelInterpolationFnc: function (value) {
                                    return value;
                                }
                            },
                            plugins: [ctHtmlLabels]
                        }
                    ]
                ];
                createChart(chartClass, window.ChartistData.data, opts, responsiveOpts);                
            }
        }, 200);
        reloadOrHideBadges();
    }

    function reloadOrHideBadges() {
        var hasDimensionsWidget = $('.contentmet-dimensions').length || $('.artmet-dimensions').length;
        if (hasDimensionsWidget &&
            window.__dimensions_embed &&
            window.__dimensions_embed.addBadges) {
            if ($('.__dimensions_badge_embed__').length) {
                $('.__dimensions_badge_embed__').removeAttr('data-dimensions-badge-installed');
                $('.__dimensions_badge_embed__').empty();
            }
            window.__dimensions_embed.addBadges();
        }
        var $altmetricBody = $('.altmetric-embed');
        if ($('.js-show-if-unknown').length && $altmetricBody.children().length === 0) {
            $('.artmet-altmetric').removeClass('hide');
        }
        // If both altmetric and citations are hidden, make sure the wrapper isn't displayed
        if (artmetBadgeIsHiddenOrEmpty() && citationsBadgeIsEmpty()) {
           $('.artmet-stats-wrap').addClass('hide');
        }
    }

    function artmetBadgeIsHiddenOrEmpty() {
        // Artmet badge can be hidden for book content pages if the count is unknown
        // but it can be displayed on Book TOC and article pages (OUP only) if the count is unknown
        return $('.artmet-altmetric').hasClass('hide');
    }

    function citationsBadgeIsEmpty() {
        // in some cases the citations badge will not be displayed at all, in other cases 
        // the artmet-citations section is hidden until the badge is displayed
        return $('.artmet-citations').length === 0;
    }

    function limitLabels() {
        // limit which labels are being displayed
        var xAxisLabels = $('.ct-horizontal.ct-label');
        var labelCt = xAxisLabels.length;

        // max number of labels to show is 8. so if there are 16..we'll show every other. 24 -- every third, etc.
        var showNthLabel = Math.ceil(labelCt / 8);
        var counter = 1;

        xAxisLabels.not(':eq(0)').each(function() {
            if (!(counter % showNthLabel === 0)) {
                $(this).hide();
            }
            counter++;
        });
    }

    function createChart(cssSelector, data, options, responsiveOptions) {
        var chart = new Chartist.Line(cssSelector, data, options, responsiveOptions);

        // Let's put a sequence number aside so we can use it in the event callbacks
        var seq = 0,
            delays = 25,
            durations = 250;

        // Once the chart is fully created we reset the sequence
        chart.on('created',
            function() {
                seq = 0;

                limitLabels();
            });

        chart.on('draw',
            function(data) {
                if (data.type === 'line' || data.type === 'point' || data.type === 'area') {
                    seq++;
                }

                if (data.type === 'line') {
                    data.element.animate({
                        opacity: {
                            begin: seq * delays + 150,
                            dur: durations,
                            from: 0,
                            to: 1
                        }
                    });
                } else if (data.type === 'point') {
                    data.element.animate({
                        x1: {
                            begin: seq * delays,
                            dur: durations,
                            from: data.x - 10,
                            to: data.x,
                            easing: 'easeOutQuart'
                        },
                        x2: {
                            begin: seq * delays,
                            dur: durations,
                            from: data.x - 10,
                            to: data.x,
                            easing: 'easeOutQuart'
                        },
                        opacity: {
                            begin: seq * delays,
                            dur: durations,
                            from: 0,
                            to: 1,
                            easing: 'easeOutQuart'
                        }
                    });
                } else if (data.type === 'area') {
                    data.element.animate({
                        opacity: {
                            begin: seq * delays + 250,
                            dur: 300,
                            from: 0,
                            to: 1
                        }
                    });
                }
            });
    }

    function getWidgetInstanceName(widgetClass) {
        var widgetInstanceName = '';
        var className = $(widgetClass).attr('class');
        var widgetInstanceIdx = className.indexOf('widget-instance-');
        if (widgetInstanceIdx >= 0) {
            widgetInstanceName = className.substr(widgetInstanceIdx).split('-')[2];
        }
        return widgetInstanceName;
    }

    function triggerModal($modal, resourceId, resourceType) {
        var showDimensionsBadge = $('.content-main .contentmet-dimensions').length ? 'true' : 'false';
        var routeUrl = '/ThirdParty/ContentLevelMetricsDetails';
        var widgetInstance = getWidgetInstanceName('.widget-ContentLevelMetrics');
        if (widgetInstance.length > 0) {
            routeUrl += '/' + widgetInstance;
        }
        routeUrl += '?resourceId=' +
            resourceId +
            '&resourceType=' +
            resourceType +
            '&showDimensionsBadge=' +
            showDimensionsBadge;

        fullVersion($modal, routeUrl);       

        var $modalWrap = $modal.closest('.artmet-modal');

        $modalWrap.css({ 'display': 'block', 'opacity': 1 });
        $modalWrap.attr('aria-hidden', 'false');
        $body.addClass('metrics-modal-open');
        $printableModal.addClass('metrics-modal-open');

        if (SCM && SCM.Focus) {
            SCM.Focus.trap($modalWrap);
        }

        $modalWrap.off('keydown.contentMetricsModal').on('keydown.contentMetricsModal', function (e) {
            if (e.key === 'Escape') {
                closeModal($modal);
            }
        });
    }

    function closeModal($modal) {
        var $modalWrap = $modal.closest('.artmet-modal');

        $modalWrap.attr('style', '');
        $modalWrap.attr('aria-hidden', 'true');
        $modalWrap.off('keydown.contentMetricsModal');
        $body.removeClass('metrics-modal-open');
        $printableModal.removeClass('metrics-modal-open');

        if (SCM && SCM.Focus) {
            SCM.Focus.release($modalWrap);
        }
    }

    function eventsToClose($modal) {
        $('.content-main .js-contentmet-close-modal').on('click',
            function() {
                closeModal($modal);
            });

        $('.content-main .js-contentmet-modal').on('click',
            function(e) {
                if (!$(e.target).closest('.artmet-modal-contents').length) {
                    closeModal($modal);
                }
            });
    }

    function registerModalClicks() {
        $('#Sidebar').on('click', '.js-contentmet-modal-trigger, .js-contentmet-views, .js-contentmet-citations', function() {
            var $modalTrigger = $('.content-main .contentmet-modal-trigger');
            var resourceId = $modalTrigger.attr('data-resource-id');
            var resourceType = $modalTrigger.attr('data-resource-type');
            triggerModal($('.content-main .artmet-modal-contents'), resourceId, resourceType);
        });
    }

    function autoLoadChart() {
        var $wrap = $('.js-metric-full-wrap[data-contentmet-autoload-chart]');
        if (!$wrap.length) {
            return;
        }

        var autoload = $wrap.attr('data-contentmet-autoload-chart');
        if (typeof autoload === 'undefined') {
            return;
        }
        if (autoload !== true && autoload.toLowerCase() !== 'true') {
            return;
        }

        var chartClass = '.ct-chart';
        if ($wrap.closest('.widget-SplitView').length) {
            $wrap.find('.js-ct-chart').addClass('sv-ct-chart');
            chartClass = '.sv-ct-chart';
        }

        var resizeObserver = new ResizeObserver(function (entries) {
            for (var i = 0; i < entries.length; i++) {
                if (entries[i].contentRect.width > 0) {
                    updateChart(ctHtmlLabels, chartClass);
                    resizeObserver.disconnect();
                }
            }
        });
        resizeObserver.observe($wrap.get(0));
    }

    function updateAltmetricPropsForBooksAndArticles(html) {
        // don't hide 0 mentions for books/articles
        // default is to hide, so check if it's not chapter view
        // and update altmetric html before adding to page
       
        if (!$('.widget-BookChapterMainView').length) {
            $('div[data-hide-no-mentions="true"]').each(function (index) {
                $(this).attr('data-hide-no-mentions', 'false');
            });
        }
    }

    // In order to hide the main content but still display the modal, 
    // we need to have the modal outside of the main div container.
    // So this function makes a clone of the modal and adds it as a child 
    // of the document body.
    function cloneMetricsModalForPrint($metricsModal) {
        if ($printableModal.length == 0 && $metricsModal.length) {
            var $printModal = $('<div/>', { 'class': 'printable-metrics-modal js-printable-metrics-modal' });

            $metricsModal.clone().appendTo($printModal);

            if ($('body.metrics-modal-open').length > 0) {
                $printModal.addClass('metrics-modal-open');
            }

            $body.append($printModal);
            $printableModal = $('.js-printable-metrics-modal');
        }
    }

    function init() {
        $(document).ready(function() {
            registerModalClicks();
            autoLoadChart();
            $(window).on('beforeprint', function () {
                // Only grab the modal contents if the modal has already been populated (js-metric-full-wrap exists)
                // Only grab the first metrics modal, in case split view and standard view have created separate modal instances.
                var $metricsModal = $('.js-metric-modal-contents:has(.js-metric-full-wrap):first');
                if ($metricsModal.length) {
                    // In order for our @print css rules to work, we need to create a clone of the modal.
                    cloneMetricsModalForPrint($metricsModal);
                }
            });
            eventsToClose($('.content-main .artmet-modal-contents'));
            // show the Shares title if badge displays           
            $('.__dimensions_badge_embed__').on('dimensions_embed:show', function () {
                $('.__dimensions_badge_embed__').closest('.artmet-item').removeClass('hide');
                $('.__dimensions_badge_embed__').closest('.contentmet-citations').removeClass('hide');
                
            });

            $('.altmetric-embed').on('altmetric:show', function () {
                $('.altmetric-embed').closest('.artmet-item').removeClass('hide');
            }); 
        });
    }
    return {
        init: init,
        triggerModal: triggerModal,
        closeModal: closeModal,
        reloadOrHideBadges: reloadOrHideBadges
    };
})(SCM.ContentMetric = SCM.ContentMetric || {});
